import { CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import Header from '../../components/Header'
import HeaderImage from '../../images/header_bg_3.jpg'
import './gallery.css'
import { useEffect, useState } from 'react';
import { Sort } from '@mui/icons-material'
import axiosInstance from '../../utils/axiosInstance';

const Gallery = () => {
  const [images, setImages] = useState([{
    title: '',
    image_url: '',
    minutes: '',
    createdAt: ''
  }])
  const [sort, setSort] = useState("");
  const [loading, setLoading] = useState(true)

  const handleSorting = (value) => {
    setSort(value);
    let sortedImages = [...images];

    switch (value) {
      case "1":
        sortedImages.sort((a, b) => parseInt(b.minutes) - parseInt(a.minutes));
        break;
      case "2":
        sortedImages.sort((a, b) => parseInt(a.minutes) - parseInt(b.minutes));
        break;
      case "3":
        sortedImages.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        break;
      case "4":
        sortedImages.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        break;
      case "0":
      default:
        break;
    }

    setImages(sortedImages);
  };

  useEffect(() => {
    const getGallery = async () => {
      setLoading(true);

      await axiosInstance.get(`gallery/all`).then((response) => {
        setLoading(false);
        setImages(response.data.data);
      }).catch((error) => {
        setLoading(false);
        if (error.response && error.response.data.message === "No images found in the gallery") {
          setImages([]);
        } else if (error.response && error.response.data.message !== "No images found in the gallery") {
          // console.error(error.response.data)
          setImages([]);
        } else {
          setImages([]);
          // console.log(error);
        }
      });
    }

    getGallery()
  }, []);

  return (
    <>
      <Header title="Our Gallery" image={HeaderImage}>
        Doloremque nobis ipsa asperiores.
        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        odio dolor eius, quod ipsa nostrum a!
      </Header>
      <div className="gallery">
        <div className="conatiner bg-white p-4 rounded-md w-56 ml-10 my-10">
          <FormControl className="w-48" style={{ marginBottom: 15 }}>
            <InputLabel>Sort <Sort /></InputLabel>
            <Select label="Select size" value={sort} onChange={(e) => handleSorting(e.target.value)}>
              <MenuItem value="0">
                Select size
              </MenuItem>
              <MenuItem value="1">
                Highest points
              </MenuItem>
              <MenuItem value="2">
                Lowest points
              </MenuItem>
              <MenuItem value="3">
                Current Images
              </MenuItem>
              <MenuItem value="4">
                Oldest images
              </MenuItem>
            </Select>
          </FormControl>
        </div>
        {loading ?
          <div className="flex justify-center items-center pt-20"><CircularProgress /></div>
        :
          <div className="w-full">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 container">
              {images.length > 0 ?
                images.map((image, index) =>
                  <article key={index} className="cursor-pointer" title={`Title: ${image.title}. Points: ${image.minutes}`} style={{ border: '1px solid #d6d6d6' }}>
                    <img src={image.image_url} alt={`Gallery item ${index + 1}`} />
                    <span className="pl-2">Points {image.minutes}</span>
                  </article>
                )
                :
                <div className="w-full text-red-500 font-bold text-center text-xl">Images not found</div>
              }
            </div>
          </div>
        }
      </div>
    </>
  )
}

export default Gallery